export function QuickCalendarIcon({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="26"
        height="64"
        viewBox="0 0 26 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 7.5C23.4853 7.5 25.5 9.51472 25.5 12V52C25.5 54.4853 23.4853 56.5 21 56.5H0.5V7.5H21Z"
          fill="currentColor"
        />
        <path
          d="M21 7.5C23.4853 7.5 25.5 9.51472 25.5 12V52C25.5 54.4853 23.4853 56.5 21 56.5H0.5V7.5H21Z"
          stroke="currentColor"
        />
        <path
          d="M11.1708 36.5V32.75M13.0004 34.625H9.25036M10.0004 24.5V26.75M16.0004 24.5V26.75M15.8579 25.565C18.3629 25.655 19.6304 26.5775 19.7054 30.1025L19.8029 34.73C19.8629 37.82 19.1504 39.3725 15.4004 39.455L10.9004 39.545C7.15036 39.62 6.37036 38.09 6.31036 35.0075L6.20536 30.3725C6.13036 26.8475 7.36786 25.8725 9.85786 25.685L15.8579 25.565Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M0 0C0 3.86599 3.13401 7 7 7H0V0Z" fill="currentColor" />
        <path d="M0 64C0 60.134 3.13401 57 7 57H0V64Z" fill="currentColor" />
      </svg>
    </span>
  );
}
